import type { RefObject } from 'react';
import { useCallback } from 'react';
import type WebView from 'react-native-webview';

import { useTelemetry } from '@order/Telemetry';

import { injectSubmitRequest } from '../injection';

/**
 * Callbacks for submitting and handling the response from the Stripe SDK.
 */
export function useStripeFormSubmission(props: StripeFormSubmissionProps) {
  const { webViewRef } = props;

  const { track } = useTelemetry();
  const handleSubmitStripeForm = useCallback(() => {
    injectSubmitRequest(webViewRef);
  }, [webViewRef]);

  const handleStripeError = useCallback(
    (userError?: string, systemError?: string) => {
      track('payment_credit.save_card_failed', { userError, systemError });
    },
    [track],
  );

  return {
    handleSubmitStripeForm,
    handleStripeError,
  };
}

// ─── Types ─────────────────────────────────────────────────────────────

type StripeFormSubmissionProps = Readonly<{
  webViewRef: RefObject<WebView | undefined>;
}>;
